<template>
  <div class="login-container">
    <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="用户名" prop="username">
        <el-input type="username" v-model="ruleForm.username" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input type="password" v-model="ruleForm.password" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      ruleForm: {
        username: '',
        password: '',
      }
    };
  },
  methods: {
    submitForm() {
      this.doLogin();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    doLogin(){
      let vm = this;
      vm.ucloading.showLoading();
      this.$api.post("/teacher/login", {username: this.ruleForm.username, password: this.ruleForm.password}, {headers: {'Content-Type': 'application/json'}}).then(res => {
        vm.ucloading.hideLoading();
        console.log(res);
        vm.$router.push({path: '/main', query: {'from': 0}});
      }).catch(res => {
        vm.ucloading.hideLoading();
        console.log(res);
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.main-container{
  height: 100%;
}
</style>